import React from 'react';
import { LayoutItem } from 'react-grid-layout';
import { ReactComponent as DeviceErrorIcon } from '../../../../../../../../assets/dashboard/DeviceError.svg';
import {
  ILabelValuePanel,
  IFlexeserveDeviceErrorPanel,
} from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import LabelValuePanel, {
  DefaultRightContainer,
} from '../../../../../../../../theme/ui/Dashboard/LabelValuePanel/LabelValuePanel';
import { useTranslation } from 'react-i18next';
import useAlarms from '../../../../../../../../redux/alarm/hooks/useAlarms';

export interface FlexeserveDeviceErrorPanelProps {
  panel: IFlexeserveDeviceErrorPanel;
  layout?: LayoutItem | undefined;
}

function FlexeserveDeviceErrorPanel(props: FlexeserveDeviceErrorPanelProps) {
  const { panel, layout } = props;
  const { t } = useTranslation();
  const { isLoading, error, count } = useAlarms(panel);

  const labelValuePanel: ILabelValuePanel = {
    type: 'LABEL_VALUE',
    id: `flexeserve_device_error`,
    title: panel.title,
    icon: <DeviceErrorIcon height={'100%'} />,
    content: (
      <DefaultRightContainer success={count === 0}>
        {count ?? 0}
      </DefaultRightContainer>
    ),
    loading: isLoading,
    error: error ? t('dashboard.error.fetching') : undefined,
  };
  return <LabelValuePanel panel={labelValuePanel} layout={layout} />;
}

export default FlexeserveDeviceErrorPanel;
